module.exports = __webpack_public_path__ + "media/images/dummy-d874b2a00f7cbd3053ddcdf0873b8ed9.svg";